const styles = {
  referralCode: {
    px: 2,
    py: 1,
    display: "flex",
    border: "2px dashed",
    borderColor: "secondary.main",
    backgroundColor: "secondary.light",
    borderRadius: 2,
    cursor: "pointer",
    maxWidth: 400,
  },
  code: {
    flexGrow: 1,
    mr: 4,
  },
  balance: {
    backgroundColor: "secondary.light",
    p: 3,
    borderRadius: 3,
    maxWidth: 600,
  },
};

export default styles;
